import React from 'react';

export const QuestionCardSkeleton: React.FC = () => {
  return (
    <div className="w-full bg-neutral-50 rounded-[20px] border-none shadow-xs p-5 animate-pulse">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2.5">
          <div className="w-[52px] h-[52px] rounded-full bg-gray-200" />
          <div className="flex flex-col gap-2">
            <div className="h-4 w-32 bg-gray-200 rounded-sm" />
            <div className="h-3 w-24 bg-gray-200 rounded-sm" />
          </div>
        </div>
        <div className="w-6 h-6 bg-gray-200 rounded-sm" />
      </div>

      {/* Title and content */}
      <div className="space-y-3 mb-4">
        <div className="h-4 w-3/4 bg-gray-200 rounded-sm" />
        <div className="h-3 w-full bg-gray-200 rounded-sm" />
        <div className="h-3 w-5/6 bg-gray-200 rounded-sm" />
      </div>

      {/* Actions */}
      <div className="flex items-center justify-between gap-2">
        <div className="h-[38px] w-16 bg-gray-200 rounded-[25px]" />
        <div className="h-[38px] w-28 bg-gray-200 rounded-[25px]" />
        <div className="h-[38px] w-28 bg-gray-200 rounded-[25px]" />
      </div>
    </div>
  );
};
